import React from 'react'
import DatePicker from 'react-datepicker'

import { InputStyled } from '../Input/Input.styles'

interface Props {
  className?: string
  endHour?: number
  handleChange: (value: Date) => void
  startHour?: number
  timeFormat?: string
  timeIntervals?: number
  value: Date
}

export const TimeInput = ({
  className = '',
  endHour,
  handleChange,
  startHour,
  timeIntervals = 15,
  timeFormat,
  value,
}: Props) => {
  const minimumTime = startHour ? new Date().setHours(startHour, 0) : undefined
  const maximumTime = endHour ? new Date().setHours(endHour, 0) : undefined

  return (
    <DatePicker
      className={className}
      css={InputStyled}
      dateFormat="h:mm aa"
      maxTime={maximumTime}
      minTime={minimumTime}
      onChange={handleChange}
      placeholderText="Select time"
      popperModifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, -8],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            rootBoundary: 'viewport',
            altAxis: true,
          },
        },
      ]}
      selected={value}
      showPopperArrow={false}
      showTimeSelect={true}
      showTimeSelectOnly={true}
      timeCaption="Time"
      timeFormat={timeFormat}
      timeIntervals={timeIntervals}
      value={value}
    />
  )
}
